<template>
<div
    ref="videoContent"
    class="tile__s__video"
    @click.stop="">
    <Player
        v-if="isHls"
        :content="content" />
        <!-- :source="hlsSources" -->
        <!-- :poster="poster"  -->
    <embed-content
        v-else-if="isEmbed"
        :embed-content="embedContent"
        :embed-poster="embedPoster" />
    <youtube
        v-else-if="isYoutube"
        :video-id="videoId" />
    <vimeo-player
        v-else-if="isVimeo"
        :video-id="videoId" />
    <video
        v-else-if="videoUrl"
        ref="video"
        controls
        :poster="posterNoDefault">
        <source :src="videoUrl">
    </video>
    <img
        v-else
        :src="imgUrl"
        onerror="this.src=process.env.DEFAULT_IMAGE"
        alt="">
</div>
</template>

<script>
    import Player from "./Player";
    import {mapGetters} from "vuex";
    import EmbedContent from "./EmbedContent";
    import getVideoId from "get-video-id";

    export default {
        components: {EmbedContent, Player},
        props: {
            content: {type: Object, default: () => {}},
        },
        computed: {
            ...mapGetters('auth', {
                currentUser: 'getCurrentUser'
            }),
            isProduct() {
                return this.content.class_name === 'Product'
            },
            video() {
                return (this.isProduct ? this.content.video : this.content.uploaded_video)
            },
            videoId() {
                return getVideoId(this.content.video).id
            },
            hlsSources() {
                if (this.isProduct) {
                    if (this.content.video_preview && this.content.video_preview.hls_sources[0]) {
                        return [this.content.video_preview.hls_sources[0]]
                    } else {
                        return null
                    }
                } else if (this.video && this.video.hls_sources[0]) {
                    return [
                        {
                            type: "application/x-mpegurl",
                            src: this.video.hls_sources[0]
                        }
                    ]
                } else {
                    return null
                }
            },
            poster() {
                let poster
                try {
                    poster = this.video.poster.md
                } catch (e) { }
                return poster || process.env.DEFAULT_IMAGE
            },
            isHls() {
                return this.video && typeof this.video == 'object' && Boolean(this.hlsSources) || false
            },
            isYoutube() {
                let yotubeRegexp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/
                return !this.isProduct && this.content.video && typeof this.content.video == 'string' && yotubeRegexp.test(this.content.video) || false
            },
            isVimeo() {
                let vimeoRegexp = /(vimeo\.com)/
                return !this.isProduct && this.content.video && typeof this.content.video == 'string' && vimeoRegexp.test(this.content.video) || false
            },
            isEmbed() {
                return (!this.isProduct && this.content.video_source_type !== 'file' && !!this.embedContent)
            },
            embedContent() {
                return (this.content.embed_url_info || {}).embed_content
            },
            embedPoster() {
                return (this.content.video_poster || {}).url
            },

            videoUrl() {
                return ((!this.isProduct && this.content.video) || (this.content.cover_video && this.content.cover_url))
            },
            imgUrl() {
                return this.content.cover_video_poster || this.content.main_image_url || this.content.logo_image || this.poster
            },
            posterNoDefault() {
                return this.imgUrl !== process.env.DEFAULT_IMAGE && this.imgUrl
            }
        },
        mounted() {
            console.log('mounted video content')
            console.log({
                video: this.content.video,
                embed: this.embedContent,
                isHls: this.isHls,
                isEmbed: this.isEmbed,
                isYoutube: this.isYoutube,
                isVimeo: this.isVimeo,
                videoUrl: this.videoUrl
            })

            console.log('CARD RAW', this.content)
            if (this.$refs.video) {
                this.$refs.video.addEventListener('error', (event) => {
                    this.$refs.videoContent.innerHTML = `<img src="${this.poster}" onerror="this.src='${process.env.DEFAULT_IMAGE}'" alt="">`;
                }, true);
            }
        },
    };
</script>

<style lang="scss">
    .tile__s__video {
        iframe {
            width: 100%;
            height: 100%;
            
            max-height: 100%;
            max-width: 100%;
        }
    }
</style>
